import {
  forwardRef,
  useEffect,
  useRef,
  useImperativeHandle,
  useState,
} from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import useUserVoice from '../../../hooks/useUserVoice.js';
import { t } from 'i18next';
import Overlay from 'react-bootstrap/Overlay';
import { toast } from 'react-toastify';
const HandleWithMic = forwardRef(
  (
    {
      activeTab,
      outputType,
      micStatus,
      loading,
      isStreaming,
      inputRef,
      pauseAudio,
      setCurrentPlayingIndex,
      isMicOn,
      setIsMicOn,
      isSpeaking,
      resetText,
      autoSubmit,
      handleInterrupt,
      setAudioMessage,
    },
    ref
  ) => {
    const {
      listening,
      resetTranscript,
      start,
      transcript,
      stop,
      userSpeaking,
    } = useUserVoice(onStart);
    const speechEndTimeoutRef = useRef(null);
    const [isInterrupted, setIsInterrupted] = useState(false);
    const [micAllowed, setMicAllowed] = useState(null);

    useEffect(() => {
    if(userSpeaking && isMicOn){

      if (isSpeaking) {
        setIsInterrupted(true)
        setTimeout(() => {
          setIsInterrupted(false)
        }, 700);
        
        pauseAudio?.();
        setCurrentPlayingIndex?.(null);
      }
        handleInterrupt();
  }
  }, [userSpeaking]);

    useImperativeHandle(ref, () => ({
      resetTranscript,
    }));

    useEffect(() => {
      if (activeTab === 'chat' && outputType === 'audio') {
        setIsMicOn(true);
      } else {
        setIsMicOn(false);
      }
    }, [activeTab, outputType]);

    const handleMic = () => {
      if (!isMicOn) {
        // Turn mic on
        start();
        setIsMicOn(true)

      } else {
        // Turn mic off
        stop();
        setIsMicOn(false)
      }
      if (micAllowed === 'granted') {

      } else if (micAllowed === 'denied') {
        toast('Microphone access is denied. Please allow it in your browser settings.');
        setIsMicOn(false)
      } else {
        toast('Microphone access is not granted yet.');
        setIsMicOn(false)
      }
    };

    useEffect(() => {
      if (navigator.permissions) {
      navigator.permissions.query({ name: 'microphone' })
        .then((status) => {
          setMicAllowed(status.state);

          // Listen for changes (e.g. user changes mic permission in settings)
          status.onchange = () => {
            setMicAllowed(status.state);
          };
        })
        .catch((err) => {
          console.warn('Permission check failed:', err);
        });
    } else {
      console.warn('Permissions API not supported');
    }
      return () => {
        stop();
      };
    }, []);

    useEffect(() => {
      if (transcript && isMicOn && outputType != 'audio') {
        const textarea = inputRef.current;
        if (resetText) {
          textarea.value = resetText + " " + transcript;
        } else {
          textarea.value = transcript;
        }
        textarea.scrollTop = textarea.scrollHeight;
      }

      if (transcript && isMicOn && outputType === 'audio') {
        setAudioMessage(transcript);
      }

      if (!userSpeaking && isMicOn && (outputType === 'audio' || outputType === 'both')) {
        speechEndTimeoutRef.current = setTimeout(() => {
          setAudioMessage('')
          autoSubmit(transcript)
        }, 2000);
      } else {
        if (speechEndTimeoutRef.current) {
          clearTimeout(speechEndTimeoutRef.current);
          speechEndTimeoutRef.current = null;
        }
      }
      if(!isMicOn){
        resetTranscript()
      }

      return () => {
        if (speechEndTimeoutRef.current) {
          clearTimeout(speechEndTimeoutRef.current);
          speechEndTimeoutRef.current = null;
        }
      };
    }, [userSpeaking, transcript]);

    const isSystemSound = () => {
      if (userSpeaking) {
        return false;
      }
      return true;
    };

    async function onStart() {
      if (!isSystemSound()) {
        if (!listening && isMicOn) {
          await start();
        }
      }
    }

    return (
      <>
      {outputType === 'audio' && <span className="position-absolute tooltip-se">{isMicOn
        ? isSpeaking
          ? t('talkToInterrupt')
          : isInterrupted ? t('interrupted')
          : listening ? t('microphoneIsOn') : ''
        : t('microphoneIsOff')}</span>}
    <button
      className={`custom-bt-mic ${userSpeaking && isMicOn ? 'speaking' : ''}`}
      disabled={!micStatus}
      onClick={handleMic}
      style={loading || isStreaming ? { pointerEvents: 'none' } : {}}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        fill='rgba(45,45,45,1)'
      >
        <path d='M11.9998 3C10.3429 3 8.99976 4.34315 8.99976 6V10C8.99976 11.6569 10.3429 13 11.9998 13C13.6566 13 14.9998 11.6569 14.9998 10V6C14.9998 4.34315 13.6566 3 11.9998 3ZM11.9998 1C14.7612 1 16.9998 3.23858 16.9998 6V10C16.9998 12.7614 14.7612 15 11.9998 15C9.23833 15 6.99976 12.7614 6.99976 10V6C6.99976 3.23858 9.23833 1 11.9998 1ZM3.05469 11H5.07065C5.55588 14.3923 8.47329 17 11.9998 17C15.5262 17 18.4436 14.3923 18.9289 11H20.9448C20.4837 15.1716 17.1714 18.4839 12.9998 18.9451V23H10.9998V18.9451C6.82814 18.4839 3.51584 15.1716 3.05469 11Z' />
        {!isMicOn && (
          <line
            x1='4'
            y1='4'
            x2='20'
            y2='20'
            stroke='black'
            strokeWidth='2'
            strokeLinecap='round'
          />
        )}
      </svg>
    </button>
    </>
    );
  }
);

export default HandleWithMic;
